import React, { useState, useEffect } from 'react';
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { Form, Input, Checkbox, Message } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { apiService } from '../../services';
import { fixID } from '../../helpers';
import { UpdateError, CollectPaymentError, ExelotError } from '../../helpers/fetchErrors';
import { PaymentPageOpts } from '../../helpers/payments';

const UpgradeDelivery = (props) => {
  const {
    history,
    getUpgradeDeliveryParcelAPI,
    updateUpgradeDeliveryParcelAPI,
    collectUpgradeDeliveryParcelAPI,
    match: { params }
  } = props;

  const [email, setEmail] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [parcelId, setParcelId] = useState(null);
  const [parcelData, setParcelData] = useState(null);
  const [error, setError] = useState();
  const [creditGuardUrl, setCreditGuardUrl] = useState();


  function handleCGPaymentCompletion(opts = {}) {
    console.log('Handling UpgradeDelivery CG Payment Completion callback');
    const { data } = opts;
    if (!data) {
      console.error('No data found');
      return;
    }

    const { status, page, res } = data;
    if (PaymentPageOpts[page] !== PaymentPageOpts.upgradeDelivery) {
      console.error(`Unexpected page ${page}`);
      return;
    }
    history.push(`/${page}/callback/${status}`, { ...res });
  }

  useEffect(() => {
    console.log('Adding UpgradeDelivery listener');
    window.addEventListener('message', handleCGPaymentCompletion, false);

    return () => {
      console.log('Removing UpgradeDelivery listener');
      window.removeEventListener('message', handleCGPaymentCompletion, false);
    };
  }, []);

  useEffect(() => {
    const id = fixID(params.parcelID);
    if (!id) {
      setError('תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.');
      return;
    }

    setParcelId(id);

    apiService
      .callServer(getUpgradeDeliveryParcelAPI, { ':id:': id }, null, null, null, true)
      .then(res => {
        setParcelData(res);
      })
      .catch(() => {
        setError('תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.');
      });
  }, []);

  const handleEmail = (e, { value }) => {
    setEmail(value);
  };

  const handleConfirm = () => {
    setConfirmed(!confirmed);
  };

  function updateEmail() {
    return apiService
      .callServer(
        updateUpgradeDeliveryParcelAPI,
        { ':id:': parcelId },
        null,
        JSON.stringify({ email }),
        null,
        true
      )
      .catch(() => {
        throw new UpdateError();
      });
  }

  function collectPayment() {
    const baseCreditGuardCallbackUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/parcels/creditguard/process_payment?page=upgradeDelivery&status=:status:`;
    const creditGuardCallbackUrls = {
      success_url: baseCreditGuardCallbackUrl.replace(':status:', 'success'),
      error_url: baseCreditGuardCallbackUrl.replace(':status:', 'error'),
      cancel_url: baseCreditGuardCallbackUrl.replace(':status:', 'cancelled')
    };

    return apiService
      .callServer(
        collectUpgradeDeliveryParcelAPI,
        { ':id:': parcelId },
        null,
        JSON.stringify({ ...creditGuardCallbackUrls }),
        null,
        true
      )
      .then(res => {
        setCreditGuardUrl(res.url);
      })
      .catch(() => {
        throw new CollectPaymentError();
      });
  }

  const handleSubmit = () => {
    setSubmitted(true);

    updateEmail()
      .then(collectPayment)
      .catch((err) => {
        if (err instanceof ExelotError) {
          setError(err.message);
          return;
        }

        // Should not happen
        console.error(err);

        // Using a default error message
        setError(new UpdateError().message);
      });
  };

  function renderError() {
    if (!error) {
      return null;
    }

    return (
      <Message
        className='error-message'
        error
        content={error}
      />
    );
  }

  if (!parcelData) {
    return renderError();
  }

  if (creditGuardUrl) {
    return (
      <Iframe
        url={creditGuardUrl}
        className='cg-iframe'
      />
    );
  }

  return (
    <div>
      {renderError()}
      {(parcelData.serviceLine === 'UHD')
        ? (
          <div className='sms-content-wrap'>
            <h1>
              המשלוח בדרך אליך!
            </h1>
            <strong className='sms-message'>
              המשלוח ישלח לכתובת:
            </strong>
            <div className='address-wrap'>
              {parcelData.name}<br />
              {parcelData.address.stAddress}<br />
              {parcelData.address.city} {parcelData.address.zip}
            </div>
            <p style={{ marginTop: '25px' }}>
              <strong>מס’ למעקב: </strong>
              <span>&nbsp; {parcelData.hawb}</span>
            </p>
            <button className='btn medium orange centered' onClick={() => props.history.push(`/tracking/${parcelData.hawb}`)}>מעקב משלוח</button>
          </div>
        ) : (
          (parcelData.hoursLeft !== null && parcelData.hoursLeft > 0)
            ? (
              <div className='sms-content-wrap'>
                <p className='sms-message'>
                  לקוח/ה יקר/ה,<br />
                  אקסלוט מציעה לכם לשדרג את חווית הקנייה ולקבל את החבילה שלכם באמצעות שליח עד פתח הבית (המשלוח יונח מחוץ לדלת). עלות השדרוג הינה {parcelData.price} ש"ח בלבד (כולל מע"מ).
                </p>

                <Form className='sms-form rtl' onSubmit={handleSubmit}>
                  <Form.Field>
                    <label htmlFor='email'>אנא הזינו כתובת אימייל למשלוח חשבונית:</label>
                    <Input type='email' name='email' required placeholder='אימייל' id='email' value={email} onChange={handleEmail} style={{ direction: 'ltr' }} />
                  </Form.Field>
                  <Form.Field inline>
                    <Checkbox name='confirm' className='rtl' required checked={confirmed} onChange={handleConfirm} />
                    <label className='confirm-label' htmlFor='confirm'>אני מאשר כי פרטי המשלוח הם:</label>
                    <div className='address-wrap'>
                      {parcelData.name}<br />
                      {parcelData.address.stAddress}<br />
                      {parcelData.address.city} {parcelData.address.zip}
                    </div>
                  </Form.Field>
                  <Form.Field inline>
                    <label>מס’ למעקב:</label>
                    <span>{parcelData.hawb}</span>
                  </Form.Field>
                  <div className='centered'>
                    <button className='btn medium orange' type='submit' disabled={!confirmed || submitted}>המשך לתשלום</button>
                  </div>
                  <div className='centered'>
                    <p className='sms-message' style={{ textDecoration: 'underline', marginTop: '10px' }}>אפשרות שדרוג המשלוח זמינה עוד <strong>{parcelData.hoursLeft}</strong> שעות</p>
                  </div>
                </Form>
              </div>
            ) : (
              <div className='sms-content-wrap'>
                <h2 className='sms-message'>
                  לקוח/ה יקר/ה,<br />
                  המשלוח בדרכו לנקודת המסירה. לא ניתן לשנות את שיטת המשלוח בשלב זה.
                </h2>
              </div>
            )
        )}
    </div>
  );
};

function mapStateToProps(state) {
  const {
    getUpgradeDeliveryParcel,
    updateUpgradeDeliveryParcel,
    collectUpgradeDeliveryParcel
  } = state.api;

  return {
    getUpgradeDeliveryParcelAPI: getUpgradeDeliveryParcel,
    updateUpgradeDeliveryParcelAPI: updateUpgradeDeliveryParcel,
    collectUpgradeDeliveryParcelAPI: collectUpgradeDeliveryParcel
  };
}

const upgradeDeliveryRouter = withRouter(connect(mapStateToProps)(UpgradeDelivery));
export { upgradeDeliveryRouter as UpgradeDelivery };
